import MockAdapter from 'axios-mock-adapter';

const {
    MOCK
} = require('../constants').default;

export default function (api) {
    // This sets the mock adapter on the default instance
    if (MOCK) {
        // mock data
        const mock = new MockAdapter(api);

        mock.onGet('resources').reply(200, [
          { id: 1, title: 'My first book.' }
        ]);
    }
}



/** WEBPACK FOOTER **
 ** ./src/core/utils/mock.js
 **/